export const enum UserType  {
    Customer = "CUSTOMER",
    Vendor = "VENDOR"
}